import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["portalClassName", "render", "showArrow", "popoverClassName"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable react/no-find-dom-node */

/* eslint-disable no-loop-func */

/* eslint-disable no-cond-assign */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { createPortal, findDOMNode } from 'react-dom';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { createElement, removeElement, setClass } from '@jd/jmtd-tools/es/element';
import { isArray, isBool } from '@jd/jmtd-tools/es/is';
import classNames from '@jd/jmtd-tools/es/classnames';
import refresh from '@jd/jmtd-tools/es/refresh';
import BasicPopover from '../BasicPopover';
import { CloseOther } from '../tools/closeOther';
import { getValue } from '../tools/util';
import PortalContext from '../PortalContext';
import { createContext } from '../tools/context';
import { PortalConsumer } from '../PortalWrapper';
import PortalZIndex from '../PortalZIndex';

var _CloseOther = CloseOther({
  isElementMatch: function isElementMatch(element, _ref) {
    var popover = _ref.popover,
        trigger = _ref.trigger;
    return element === popover || element === trigger;
  }
}),
    closeOther = _CloseOther.closeOther,
    addNode = _CloseOther.addNode,
    removeNode = _CloseOther.removeNode;

var arrowHalfSize = 4;
var direction = ['left', 'top', 'right', 'bottom'];
var portalCache = {};
export var SUB_ALIGN = Symbol('SUB_ALIGN');
var PopoverContext = createContext(undefined); // 判断数组1是否容纳了数组2

function contains(lhs, rhs) {
  if (isArray(rhs) && isArray(lhs)) {
    var i = 0;

    var _iterator = _createForOfIteratorHelper(rhs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;

        if (o !== lhs[i++]) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  return true;
}

var Popover = /*#__PURE__*/function (_PureComponent) {
  _inherits(Popover, _PureComponent);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);
    _this.open = false;
    _this.cxt = {};
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      this.update();
      var popoverRef = this.popoverRef,
          exclusive = this.exclusive,
          popoverPath = this.popoverPath,
          notTriggerByItself = this.props.notTriggerByItself;

      if (this.open && !this.init) {
        this.init = true;
        this.refreshHandle = refresh(function () {
          _this2.updatePosition();
        });
      }

      if (this.init) {
        this.updatePosition();
        this.updateOpen();
      } // 如果设置排他，添加到排他节点中


      if (exclusive) {
        var node = this.node;

        if (!node) {
          node = this.node = {
            exclusive: exclusive,
            popoverPath: popoverPath,
            check: function check(target) {
              // exclusive为true为与所有其他互斥
              // exclusive相同则彼此相容
              if ((target === null || target === void 0 ? void 0 : target.exclusive) === true || exclusive === true || (target === null || target === void 0 ? void 0 : target.exclusive) !== exclusive && (target !== null && target !== void 0 && target.exclusive || exclusive)) {
                return contains(target === null || target === void 0 ? void 0 : target.popoverPath, popoverPath);
              }

              if ((target === null || target === void 0 ? void 0 : target.exclusive) === exclusive) {
                return false;
              }

              return true;
            },
            close: function close() {
              _this2.setOpen(false);
            }
          };
          addNode(node);
        } // notTriggerByItself：不被自己触发，在这种情况下忽略触发器


        [[popoverRef, 'popover']].concat(notTriggerByItself ? [] : [[findDOMNode(this), 'trigger']]).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              el = _ref3[0],
              fieldName = _ref3[1];

          if (el) {
            var _el$Popover;

            node[fieldName] = el;
            (_el$Popover = el.Popover) !== null && _el$Popover !== void 0 ? _el$Popover : el.Popover = _this2;
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // 取消挂载时移除节点，清除轮询
      this.node && removeNode(this.node);
      this.refreshHandle && this.refreshHandle.remove(); // 如果引用计数为0，清除portal，删除缓存中的对象。

      if (--this.portal.Count === 0) {
        var portalClassName = this.props.portalClassName;
        delete portalCache[portalClassName];
        removeElement(this.portal);
      }
    } // 设置打开状态

  }, {
    key: "setOpen",
    value: function setOpen(val) {
      if (this.disableClose) {
        return;
      }

      var open = this.open,
          exclusive = this.exclusive;

      if (open !== val) {
        if (val) {
          // 如果是排他，关闭其他同分组节点。
          if (exclusive) {
            closeOther(this.node);
          }
        } else {
          this.onClose();
        }

        this.open = val;
        this.forceUpdate();
      }
    } // 回调onUpdate函数

  }, {
    key: "update",
    value: function update() {
      var cxt = this.cxt,
          onUpdate = this.props.onUpdate,
          popoverRef = this.popoverRef;
      var triggerNode = findDOMNode(this);
      popoverRef && (popoverRef.$$ReactParent = triggerNode);
      var updateEvent = {
        triggerNode: triggerNode,
        state: cxt,
        self: this
      };
      onUpdate(updateEvent);
      this.onUpdate && this.onUpdate(updateEvent);
      this.triggerNode = triggerNode;
    } // 更新open状态

  }, {
    key: "updateOpen",
    value: function updateOpen() {
      var open = this.open,
          _this$props = this.props,
          openClassName = _this$props.openClassName,
          visibility = _this$props.visibility,
          popoverRef = this.popoverRef,
          triggerNode = this.triggerNode;
      var visible = getValue(visibility, triggerNode); // 如果设置了可见性函数，根据可见性函数做可见性判断

      var realOpen = open && visible;
      [triggerNode, popoverRef].forEach(function (node) {
        setClass(node, ['jmtd-popover-open'].concat(openClassName || []), realOpen);
      });
      this.onUpdateOpen({
        triggerNode: triggerNode,
        popoverNode: popoverRef,
        open: realOpen
      });
    } // 根据按钮的位置，计算弹出板展示的位置

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var triggerNode = this.triggerNode,
          open = this.open,
          popoverRef = this.popoverRef,
          arrowRef = this.arrowRef,
          _this$props2 = this.props,
          placement = _this$props2.placement,
          showArrow = _this$props2.showArrow,
          arrowPointAtCenter = _this$props2.arrowPointAtCenter,
          autoAdjustOverflow = _this$props2.autoAdjustOverflow,
          adjustMainSize = _this$props2.adjustMainSize,
          portal = this.portal;
      var _this$props$margin = this.props.margin,
          margin = _this$props$margin === void 0 ? showArrow ? 5 : 2 : _this$props$margin;

      if (showArrow) {
        margin += 5;
      }

      if (open && triggerNode.getBoundingClientRect) {
        var _placement$split = placement.split(/([A-Z].*)/g),
            _placement$split2 = _slicedToArray(_placement$split, 2),
            mainDirection = _placement$split2[0],
            _placement$split2$ = _placement$split2[1],
            subDirection = _placement$split2$ === void 0 ? '' : _placement$split2$; // 将placement拆解为主位置和次位置，如'topLeft'拆为'top'和'left'，'top'拆为left和''


        var realMainDirection = mainDirection;
        var subAlign = 0.5; // 次位置对齐

        if (subDirection) {
          subAlign = {
            Left: 0,
            Right: 1,
            Top: 0,
            Bottom: 1
          }[subDirection];
        }

        if (SUB_ALIGN in popoverRef) {
          subAlign = popoverRef[SUB_ALIGN];
        }

        var _triggerNode$getBound = triggerNode.getBoundingClientRect(),
            triggerRawX = _triggerNode$getBound.x,
            triggerRawY = _triggerNode$getBound.y,
            triggerWidth = _triggerNode$getBound.width,
            triggerHeight = _triggerNode$getBound.height;

        var _portal$getBoundingCl = portal.getBoundingClientRect(),
            rootX = _portal$getBoundingCl.x,
            rootY = _portal$getBoundingCl.y; // portal在特殊情况下不一定在页面右上，比如在shadow-dom中


        var triggerX = triggerRawX - rootX,
            triggerY = triggerRawY - rootY; // 计算triggerNode的相对于portal的位置

        var _window$getComputedSt = window.getComputedStyle(popoverRef),
            styleWidth = _window$getComputedSt.width,
            styleHeight = _window$getComputedSt.height;

        var _map = [styleWidth, styleHeight].map(function (x) {
          return parseFloat(x);
        }),
            _map2 = _slicedToArray(_map, 2),
            popoverWidth = _map2[0],
            popoverHeight = _map2[1];

        var _document$documentEle = document.documentElement,
            clientWidth = _document$documentEle.clientWidth,
            clientHeight = _document$documentEle.clientHeight;
        var popoverStyle = {}; // 弹出框样式

        var arrowStyle = {}; // 箭头原始
        // 计算主方向的位置

        var getMainDirectionPos = function getMainDirectionPos(mainTriggerPos, mainTriggerSize, mainPopoverSize, mainClientSize, directions) {
          var adjustSize = adjustMainSize || mainPopoverSize; // 自适应尺寸

          var pos = [mainTriggerPos - margin - mainPopoverSize, mainTriggerPos + mainTriggerSize + margin];
          var space = [mainTriggerPos - margin, mainClientSize - (mainTriggerPos + mainTriggerSize + margin)];
          var realIndex = directions.findIndex(function (x) {
            return x === mainDirection;
          });
          var opposedIndex = 1 - realIndex; // 如果本侧空间不够，而对侧空间能容纳弹出内容，使用对侧控件

          if (autoAdjustOverflow === 'auto' || autoAdjustOverflow === 'main') {
            if (space[realIndex] < adjustSize && space[opposedIndex] >= adjustSize) {
              realIndex = opposedIndex;
              realMainDirection = directions[realIndex];
            }
          }

          return px(pos[realIndex]);
        }; // 计算次方向的位置


        var getSubDirectionPos = function getSubDirectionPos(subTriggerPos, subTriggerSize, subPopoverSize, subClientSize) {
          var getArrowPos = function getArrowPos(align) {
            return (subPopoverSize - 40 - arrowHalfSize * 2) * align + 20;
          };

          var getPos = function getPos(align) {
            return subTriggerPos + (subTriggerSize - subPopoverSize) * align;
          };

          var pos;
          var arrowPos = getArrowPos(subAlign);

          if (arrowPointAtCenter) {
            pos = getPos(0.5) + (getArrowPos(0.5) - arrowPos);
          } else {
            pos = getPos(subAlign);
          }

          function setNewPos(nextPos) {
            if (arrowPointAtCenter) {
              arrowPos += pos - nextPos;
            }

            pos = nextPos;
          } // 移动到屏幕内


          if (autoAdjustOverflow === 'auto' || autoAdjustOverflow === 'sub') {
            if (pos < 0) {
              setNewPos(0);
            } else if (pos + subPopoverSize > subClientSize) {
              setNewPos(Math.floor(subClientSize - subPopoverSize));
            }
          }

          return {
            pos: px(pos),
            arrowPos: px(arrowPos)
          };
        };

        if (mainDirection === 'left' || mainDirection === 'right') {
          var _getSubDirectionPos = getSubDirectionPos(triggerY, triggerHeight, popoverHeight, clientHeight),
              pos = _getSubDirectionPos.pos,
              arrowPos = _getSubDirectionPos.arrowPos;

          popoverStyle.left = getMainDirectionPos(triggerX, triggerWidth, popoverWidth, clientWidth, ['left', 'right']);
          popoverStyle.top = pos;
          arrowStyle.top = arrowPos;
        } else {
          var _getSubDirectionPos2 = getSubDirectionPos(triggerX, triggerWidth, popoverWidth, clientWidth),
              _pos = _getSubDirectionPos2.pos,
              _arrowPos = _getSubDirectionPos2.arrowPos;

          popoverStyle.top = getMainDirectionPos(triggerY, triggerHeight, popoverHeight, clientHeight, ['top', 'bottom']);
          popoverStyle.left = _pos;
          arrowStyle.left = _arrowPos;
        } // 设置箭头的位置


        if (arrowRef) {
          arrowStyle[realMainDirection] = '100%';
          arrowStyle["margin-".concat(realMainDirection)] = px(-arrowHalfSize); // 设置箭头位置class，用于控制阴影

          direction.forEach(function (x) {
            setClass(arrowRef, "jmtd-popover-arrow-".concat(x), x === realMainDirection);
          });
          removeCss(arrowRef, direction);
          css(arrowRef, arrowStyle);
        } // 设置弹出面板位置class，用于控制动画


        direction.forEach(function (x) {
          setClass(popoverRef, "jmtd-popover-".concat(x), x === realMainDirection);
        });
        css(popoverRef, popoverStyle);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          portalClassName = _this$props3.portalClassName,
          render = _this$props3.render,
          showArrow = _this$props3.showArrow,
          popoverClassName = _this$props3.popoverClassName,
          otherProps = _objectWithoutProperties(_this$props3, _excluded);

      var open = this.open; // 如果是受控模式，根据open决定是否打开

      if (otherProps.trigger === 'control') {
        open = this.open = otherProps.open;
      }

      return /*#__PURE__*/React.createElement(PortalZIndex, null, function (_ref4) {
        var portalStyle = _ref4.style,
            enable = _ref4.enable;
        return /*#__PURE__*/React.createElement(PortalConsumer, null, function (portalRoot) {
          if (!_this3.portal) {
            var newPortal = function newPortal() {
              return createElement('div.jmtd-popover-portal', {
                style: portalStyle,
                classList: (portalClassName ? portalClassName.split(' ') : []).concat(enable ? ['jmtd-portal-adjust'] : [])
              }, portalRoot !== null && portalRoot !== void 0 ? portalRoot : document.body);
            };

            if (enable) {
              // 如果启用了portal-z-index，不使用portal缓存
              _this3.portal = newPortal();
            } else {
              var _portalCache$portalCl;

              // 未启用portal-z-index的情况，使用portal缓存
              _this3.portal = (_portalCache$portalCl = portalCache[portalClassName]) !== null && _portalCache$portalCl !== void 0 ? _portalCache$portalCl : portalCache[portalClassName] = newPortal();
            }

            _this3.portal.Count = (_this3.portal.Count || 0) + 1; // 引用计数
          }

          return /*#__PURE__*/React.createElement(PopoverContext.Consumer, null, function (parentPath) {
            try {
              var _render = render({
                state: _this3.cxt,
                update: function update() {
                  _this3.forceUpdate();
                },
                open: open,
                setOpen: function setOpen(val) {
                  return _this3.setOpen(val);
                },
                triggerNode: _this3.triggerNode
              }, otherProps),
                  _render$className = _render.className,
                  renderClassName = _render$className === void 0 ? '' : _render$className,
                  _render$popoverProps = _render.popoverProps,
                  popoverProps = _render$popoverProps === void 0 ? {} : _render$popoverProps,
                  _render$style = _render.style,
                  style = _render$style === void 0 ? {} : _render$style,
                  popover = _render.popover,
                  children = _render.children,
                  otherChildren = _render.otherChildren,
                  _render$exclusive = _render.exclusive,
                  exclusive = _render$exclusive === void 0 ? false : _render$exclusive,
                  disableClose = _render.disableClose,
                  onUpdate = _render.onUpdate,
                  _render$onClose = _render.onClose,
                  onClose = _render$onClose === void 0 ? function () {} : _render$onClose,
                  visibility = _render.visibility,
                  _render$onUpdateOpen = _render.onUpdateOpen,
                  onUpdateOpen = _render$onUpdateOpen === void 0 ? function () {} : _render$onUpdateOpen;

              var visible = isBool(visibility) ? visibility : true; // 可见性
              // 获取当前组件的排他symbol
              // eslint-disable-next-line no-return-assign

              var getThisExclusiveSymbol = function getThisExclusiveSymbol() {
                var _this3$exclusiveSymbo;

                return (_this3$exclusiveSymbo = _this3.exclusiveSymbol) !== null && _this3$exclusiveSymbo !== void 0 ? _this3$exclusiveSymbo : _this3.exclusiveSymbol = Symbol(new Date().getTime());
              };

              Object.assign(_this3, {
                children: children,
                disableClose: disableClose,
                onClose: onClose,
                onUpdate: onUpdate,
                onUpdateOpen: onUpdateOpen,
                // 如果排他性为true，指定一个symbol，与任何其他弹出框互斥
                exclusive: exclusive,
                // popover路径
                popoverPath: parentPath ? parentPath.concat(getThisExclusiveSymbol()) : [getThisExclusiveSymbol()]
              });

              if (!_this3.opened && open) {
                _this3.opened = true;
              }

              return /*#__PURE__*/React.createElement(React.Fragment, null, children, popover && visible && _this3.opened && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(PortalContext, null, /*#__PURE__*/React.createElement(PopoverContext.Provider, {
                value: _this3.popoverPath
              }, disableClose && open && /*#__PURE__*/React.createElement("div", {
                className: "jmtd-popover-wall"
              }), /*#__PURE__*/React.createElement("div", _extends({}, popoverProps, {
                ref: function ref(el) {
                  _this3.popoverRef = el;
                },
                style: style,
                className: classNames('jmtd-popover', renderClassName, popoverClassName)
              }), showArrow && /*#__PURE__*/React.createElement("div", {
                className: "jmtd-popover-arrow",
                ref: function ref(el) {
                  _this3.arrowRef = el;
                }
              }, /*#__PURE__*/React.createElement("div", {
                className: "jmtd-popover-arrow-content"
              })), showArrow ? /*#__PURE__*/React.createElement("div", {
                className: "jmtd-popover-content"
              }, popover) : popover))), _this3.portal), otherChildren);
            } catch (e) {
              // eslint-disable-next-line no-console
              console.error(e);
              return /*#__PURE__*/React.createElement("div", null);
            }
          });
        });
      });
    }
  }]);

  return Popover;
}(PureComponent);

export { Popover as default };
Popover.propTypes = {
  render: PropTypes.func,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),
  openClassName: PropTypes.string,
  showArrow: PropTypes.bool,
  children: PropTypes.node,
  popover: PropTypes.any,
  trigger: PropTypes.oneOf(['click', 'hover', 'control']),
  popoverClassName: PropTypes.string,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  visibility: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  arrowPointAtCenter: PropTypes.bool,
  portalClassName: PropTypes.string,
  onUpdate: PropTypes.func,
  margin: PropTypes.number,
  // 弹出框和触发器的间距
  open: PropTypes.bool,
  autoAdjustOverflow: PropTypes.oneOf(['auto', 'main', 'sub', 'none']),
  adjustMainSize: PropTypes.number,
  'data-component-name': PropTypes.string,
  notTriggerByItself: PropTypes.bool
};
Popover.defaultProps = {
  render: BasicPopover,
  placement: 'bottom',
  openClassName: '',
  showArrow: true,
  children: null,
  popover: null,
  trigger: 'hover',
  popoverClassName: '',
  mouseEnterDelay: 300,
  mouseLeaveDelay: 300,
  visibility: true,
  arrowPointAtCenter: false,
  portalClassName: '',
  onUpdate: function onUpdate() {},
  margin: undefined,
  open: null,
  autoAdjustOverflow: 'auto',
  adjustMainSize: null,
  'data-component-name': '',
  notTriggerByItself: false
};
export { closeOther as closeOtherPopover };